import axios from 'axios';
import { athenaBaseUrl, GET, POST } from '../../../utils/axios-interceptor';

// API Endpoints for Ask Aica feature - make sure there's no trailing slash
const API_ENDPOINTS = {
    CHAT: '/chat',
    CHAT_HISTORY: '/chat/conversation/history',
    CLEAR_MEMORY: '/chat/memory/clear',
};

/**
 * Get the necessary headers for API requests
 * @returns Headers object with authentication tokens
 */
function getAuthHeaders(orgId?: string, userId?: string) {
    const ls = typeof window !== 'undefined' ? window.localStorage : undefined;
    const cerberusToken = ls?.getItem('auth_token') ?? '';
    const org_Id = orgId ?? ls?.getItem('org_id') ?? '';
    const user_Id = userId ?? ls?.getItem('user_id') ?? '';
    return {
        'Content-Type': 'application/json',
        'x-cerberus-token': cerberusToken,
        'x-user-id': user_Id,
        'x-organization-id': org_Id,
    };
}

/**
 * Send a non-streaming chat request
 */
export function sendChatRequest(payload: {
    messages: Array<{ role: string; content: string }>;
    userId?: string;
    orgId?: string;
    sources?: string[];
}) {
    return axios({
        method: POST,
        url: `${CHAT_CONFIG.URL}`,
        headers: getAuthHeaders(payload.orgId, payload.userId),
        data: {
            messages: payload.messages,
            stream: false,
            user_id: payload.userId,
            org_id: payload.orgId,
            sources: payload.sources || ['searchTheWeb'],
        },
    });
}

export function getChatHistoryService(payload: { userId?: string; orgId?: string; pageNum: number; pageSize: number }) {
    return axios({
        method: GET,
        url: `${athenaBaseUrl}${API_ENDPOINTS.CHAT_HISTORY}`,
        headers: getAuthHeaders(payload.orgId, payload.userId),
        params: {
            user_id: payload.userId,
            org_id: payload.orgId,
            page: payload.pageNum,
            page_size: payload.pageSize,
        },
    });
}

export function clearMemoryService(payload: { userId: string; orgId: string }) {
    return axios({
        method: POST,
        url: `${athenaBaseUrl}${API_ENDPOINTS.CLEAR_MEMORY}`,
        headers: getAuthHeaders(payload.orgId, payload.userId),
        data: {
            user_id: payload.userId,
            org_id: payload.orgId,
        },
    });
}

/**
 * Chat API configuration
 */
export const CHAT_CONFIG = {
    URL: `${athenaBaseUrl}${API_ENDPOINTS.CHAT}`,
    getHeaders: getAuthHeaders,
};
